import { BIRDVIEW_LAYOUT_COLUMN } from '../../../DashboardBirdview'
import { OVERVIEW_PAYLOAD_FIELD } from '../RentalPortalOverview.constants'
import {
  getOverviewApprovalShowAllLink,
  RentalPortalOverviewApprovalRow,
} from '../RentalPortalOverviewApprovalRow'
import {
  getOverviewAttentionShowAllLink,
  RentalPortalOverviewAttentionRow,
} from '../RentalPortalOverviewAttentionRow'
import {
  getOverviewCommunicationsShowAllLink,
  RentalPortalOverviewCommunicationRow,
} from '../RentalPortalOverviewCommunicationRow'
import {
  getOverviewViewingsShowAllLink,
  RentalPortalOverviewViewingRow,
} from '../RentalPortalOverviewViewingRow'

export const QA_NAME_OVERVIEW_PANEL_AWAITING_APPROVAL =
  'rentalPortalOverviewAwaitingApproval'

export const QA_NAME_OVERVIEW_PANEL_COMMUNICATIONS =
  'rentalPortalOverviewCommunications'

export const QA_NAME_OVERVIEW_PANEL_NEEDS_ATTENTION =
  'rentalPortalOverviewNeedsAttention'

export const QA_NAME_OVERVIEW_PANEL_UPCOMING_VIEWINGS =
  'rentalPortalOverviewUpcomingViewings'

export const OVERVIEW_PANEL_ROW_KEY_SEPARATOR = '-'

export const OVERVIEW_PANEL_LIST_LEFT = [
  {
    emptyTextKey: 'RentalPortal.OverviewApprovalEmptyKey',
    field: OVERVIEW_PAYLOAD_FIELD.awaitingApproval,
    qaName: QA_NAME_OVERVIEW_PANEL_AWAITING_APPROVAL,
    rowKeyFields: ['applicant_id'],
    titleKey: 'RentalPortal.OverviewPanelAwaitingApprovalKey',
    totalField: OVERVIEW_PAYLOAD_FIELD.awaitingApprovalTotal,
  },
  {
    emptyTextKey: 'RentalPortal.OverviewCommunicationsEmptyKey',
    field: OVERVIEW_PAYLOAD_FIELD.communications,
    qaName: QA_NAME_OVERVIEW_PANEL_COMMUNICATIONS,
    rowKeyFields: ['thread_id'],
    titleKey: 'RentalPortal.OverviewPanelCommunicationsKey',
    totalField: OVERVIEW_PAYLOAD_FIELD.communicationsTotal,
  },
]

export const OVERVIEW_PANEL_LIST_RIGHT = [
  {
    emptyTextKey: 'RentalPortal.OverviewAttentionEmptyKey',
    field: OVERVIEW_PAYLOAD_FIELD.needsAttention,
    qaName: QA_NAME_OVERVIEW_PANEL_NEEDS_ATTENTION,
    rowKeyFields: ['type', 'listing_id'],
    titleKey: 'RentalPortal.OverviewNeedsAttentionTitleKey',
    totalField: OVERVIEW_PAYLOAD_FIELD.needsAttentionTotal,
  },
  {
    emptyTextKey: 'RentalPortal.OverviewViewingsEmptyKey',
    field: OVERVIEW_PAYLOAD_FIELD.upcomingViewings,
    qaName: QA_NAME_OVERVIEW_PANEL_UPCOMING_VIEWINGS,
    rowKeyFields: ['viewing_id'],
    titleKey: 'RentalPortal.OverviewPanelUpcomingViewingsKey',
    totalField: OVERVIEW_PAYLOAD_FIELD.upcomingViewingsTotal,
  },
]

export const OVERVIEW_PANEL_DEFAULT_LAYOUT = {
  [BIRDVIEW_LAYOUT_COLUMN.left]: OVERVIEW_PANEL_LIST_LEFT.map(
    panel => panel.field
  ),
  [BIRDVIEW_LAYOUT_COLUMN.right]: OVERVIEW_PANEL_LIST_RIGHT.map(
    panel => panel.field
  ),
}

export const OVERVIEW_PANEL_LIST = [
  ...OVERVIEW_PANEL_LIST_LEFT,
  ...OVERVIEW_PANEL_LIST_RIGHT,
]

export const OVERVIEW_PANEL_ROW_BY_FIELD = {
  [OVERVIEW_PAYLOAD_FIELD.awaitingApproval]: RentalPortalOverviewApprovalRow,
  [OVERVIEW_PAYLOAD_FIELD.communications]: RentalPortalOverviewCommunicationRow,
  [OVERVIEW_PAYLOAD_FIELD.needsAttention]: RentalPortalOverviewAttentionRow,
  [OVERVIEW_PAYLOAD_FIELD.upcomingViewings]: RentalPortalOverviewViewingRow,
}

export const OVERVIEW_PANEL_SHOW_ALL_BY_FIELD = {
  [OVERVIEW_PAYLOAD_FIELD.awaitingApproval]: getOverviewApprovalShowAllLink,
  [OVERVIEW_PAYLOAD_FIELD.communications]: getOverviewCommunicationsShowAllLink,
  [OVERVIEW_PAYLOAD_FIELD.needsAttention]: getOverviewAttentionShowAllLink,
  [OVERVIEW_PAYLOAD_FIELD.upcomingViewings]: getOverviewViewingsShowAllLink,
}
